export enum AvailabilityStatusEnum {
  'AVAILABLE' = 'AVAILABLE',
  'UNAVAILABLE' = 'UNAVAILABLE',
  'WORKING' = 'WORKING',
}

export enum AvailabilityStatusAfterCancelEnum {
  'AVAILABLE' = 'AVAILABLE',
  'UNAVAILABLE' = 'UNAVAILABLE',
  'UNKNOWN' = 'UNKNOWN',
}
